import Bestandsaufnahme from "@/models/ba/Bestandsaufnahme";
import { Fragenblock } from "@/models/ba/Fragenblock";
import { FrageJson } from "@/models/ba/interfaces/IFrage";
import Immobilie from "@/models/immobilie.model";
import User from "@/models/user";
import moment from "moment";

export const getFilename = (prefix = "surveys") => {
    return `${prefix}-export-${moment().format('YYYY_MM_DD_HHmmss')}`;
};

interface GeoJsonExportConfigElement {
    label: string;
    frage_path?: string;
    special_field?: string;
    prop_field?: string;
}

export type GeoJsonExportConfig = GeoJsonExportConfigElement[];

// This is a temporary function to return a hardcoded GeoJSON export configuration.
// TODO: Get configuration from db
export const getGeoJsonExportConfig = (): GeoJsonExportConfig => {

    return [{
        label: "Titel",
        frage_path: "custom-title.eingabeText"
    }, {
        label: "Anmerkung",
        frage_path: "custom-freitext.eingabeText"
    }, {
        label: "Person",
        special_field: "resolve_user_from_fragenblock"
    }, {
        label: "MastNr",
        prop_field: "name",
    }, {
        label: "AnlagenNr",
        prop_field: "stadt",
    }];
};

export const resolveFragenblockGeoJsonExportConfig =
    async (property: Immobilie, survey: Bestandsaufnahme, fragenblock: Fragenblock, config: GeoJsonExportConfig, users: User[]) => {
        const result: Record<string, any> = {};
        for (const key in config) {
            const value = config[key];
            if (!value) continue;

            if (value.frage_path) {
                const fragePath = value.frage_path.substring(0, value.frage_path.lastIndexOf("."));
                const frage = fragenblock.findFrageByRelativePath(survey, fragePath);
                if (frage) {
                    const fieldName: keyof FrageJson = value.frage_path.substring(value.frage_path.lastIndexOf(".") + 1) as keyof FrageJson;
                    const frageJson = await frage.toLeanJson();
                    const fieldValue = frageJson[fieldName];
                    result[value.label] = fieldValue;
                } else {
                    result[value.label] = "Frage not found";
                }

            } else if (value.special_field) {
                if (value.special_field === "resolve_user_from_fragenblock") {
                    try {
                        const userId = fragenblock.getUserIdFromFragenblockConfig();
                        if (!userId) {
                            result.push({ [key]: "No user ID found in Fragenblock" });
                            continue;
                        }
                        const user = users.find(u => u.id === userId);
                        result[value.label] = user ? user.username : "User not found";
                    } catch (error) {
                        console.error("Error resolving user from Fragenblock:", error);
                        result[value.label] = "Error resolving user";
                    }
                }
            } else if (value.prop_field) {
                try {
                    // @ts-ignore property can't be index typed like this.
                    result[value.label] = property ? property?.[value.prop_field] : "Property not found";
                } catch (error) {
                    console.error("Error accessing property field:", error);
                    result[value.label] = "Error accessing property field";
                }
            }
        }
        return result;
    };